import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { FiLogOut } from 'react-icons/fi';
import './LogoutButton.css';

/**
 * Standardized Logout Button Component
 * Provides consistent logout functionality across all pages
 */
const LogoutButton = ({ variant = 'default', className = '' }) => {
    const navigate = useNavigate();
    const { logout } = useAuth();

    const handleLogout = () => {
        logout();
        navigate('/login');
    };

    return (
        <button 
            onClick={handleLogout}
            className={`logout-button logout-button-${variant} ${className}`}
            title="Logout"
        >
            <FiLogOut className="logout-icon" />
            <span className="logout-text">Logout</span>
        </button>
    );
};

export default LogoutButton;
